import useClient from "./useClient";
import { useLocation } from "react-router-dom";
import useQueryParams, { TERRITORY_PARAM } from "./useQueryParams";

const useEditRights = () => {
  const { queryParams } = useQueryParams();
  const { role } = useClient();
  const territory = queryParams.get(TERRITORY_PARAM) ?? "";
  const decodedURI = decodeURIComponent(territory);

  const canEdit =
    !role.includes("read") &&
    (role.toLowerCase().includes("admin") ||
      decodedURI.toLowerCase().includes(role.toLowerCase()));
  return { canEdit };
};

export default useEditRights;
